/* eslint-disable no-template-curly-in-string */
import { pushEvent, trackifyInit } from '@allianz/tracking';
import { UserProfileIDService } from 'gw-capability-claim';
import { ClaimService } from 'gw-capability-claim';
function getPageName() {
    if (window.digitalData) {
        if (window.digitalData.spaData) {
            if (window.digitalData.spaData.AllianzClaimsHub) {
                if (window.digitalData.spaData.AllianzClaimsHub.applicationLoaded) {
                    if (window.location.pathname.includes('fnol-select-policy') || window.location.pathname.includes('fnol-ca/select-policy') || window.location.pathname === '/claimshub/fnol-ca') {
                        return 'FNOL - Select Policy';
                    } if (window.location.pathname.includes('fnol-ca/what')) {
                        return 'FNOL - What';
                    } if (window.location.pathname.includes('fnol-ca/details')) {
                        return 'FNOL - Details';
                    } if (window.location.pathname.includes('fnol-ca/Vehicles')) {
                        return 'FNOL - Vehicles';
                    } if (window.location.pathname.includes('fnol-ca/type-of-repair') || window.location.pathname.includes('fnol-ca/repair')) {
                        return 'FNOL - Repair';
                    } if (window.location.pathname.includes('fnol-ca/additionalinformation')) {
                        return 'FNOL - Additional Information';
                    } if (window.location.pathname.includes('fnol-ca/contact-details')) {
                        return 'FNOL - Contact';
                    } if (window.location.pathname.includes('fnol-ca/summary')) {
                        return 'FNOL - Summary';
                    } if (window.location.pathname.includes('/claimshub/confirmation/')) {
                        return 'FNOL - Confirmation';
                    } if (window.location.pathname.includes('/claimshub/claims/')) {
                        return 'Individual Claim';
                    } if (window.location.pathname.includes('/claimshub/claims')) {
                        return 'Claims Hub Dashboard';
                    } if (window.location.pathname.includes('/claimshub/login-page')) {
                        return window.digitalData.spaData.AllianzClaimsHub.applicationLoaded.newPage;
                    } if (window.location.pathname.includes('/claimshub/faq')) {
                        return 'FAQ';
                    }
                    return '';
                }
                return 'AZ dashboard';
            }
            return 'AZ dashboard';
        }
        return 'AZ dashboard';
    }

    return '';
}

function initialiseTrackify() {
    trackifyInit({
        appName: 'Allianz Claims Hub',
        pageId: getPageName()
    });
}

function tabChange(activeTab) {
    switch (activeTab) {
        case ('summaryTab'): {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: 'claimshub_claim.summary'
                    }
                },
            };
            pushEvent('summaryTabChanged', 'claimshub_claim.summary', true);
        } break;
        case ('notesTab'): {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: 'claimshub_claim.notes'
                    }
                },
            };
            pushEvent('summaryTabChanged', 'claimshub_claim.notes', true);
        } break;
        case ('documentsTab'): {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: 'claimshub_claim.documents'
                    }
                },
            };
            pushEvent('summaryTabChanged', 'claimshub_claim.documents', true);
        } break;
        case ('financialsTab'): {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: 'claimshub_claim.financials'
                    }
                },
            };
            pushEvent('summaryTabChanged', 'claimshub_claim.financials', true);
        } break;
        case ('repairTab'): {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: 'claimshub_claim.repair'
                    }
                },
            };
            pushEvent('summaryTabChanged', 'claimshub_claim.repair', true);
        } break;
        case ('settlementLetterTab'): {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: 'claimshub_claim.settlementletter'
                    }
                },
            };
            pushEvent('summaryTabChanged', 'claimshub_claim.settlementletter', true);
        } break;
        default: {
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: ''
                    }
                },
            };
        }
    }
}

function getSiteSection() {
    if (window.location.pathname.includes('fnol')) {
        return 'FNOL Process';
    } if (window.location.pathname.includes('/claimshub/claims/')) {
        return 'Individual Claim';
    }
    return 'Claims Hub Dashboard';
}
function getPageType() {
    if (window.location.pathname.includes('fnol')) {
        return 'FNOL Page';
    } if (window.location.pathname.includes('/claimshub/claims/')) {
        return 'Individual Claim Page';
    }
    return 'Dashboard';
}

function getPreviousPageName() {
    if (digitalData) {
        if (digitalData.spaData) {
            if (digitalData.spaData.AllianzClaimsHub) {
                if (digitalData.spaData.AllianzClaimsHub.pageChanged) {
                    if (window.digitalData.spaData.AllianzClaimsHub.pageChanged.oldPage) {
                        return window.digitalData.spaData.AllianzClaimsHub.pageChanged.oldPage;
                    }
                }
            }
        }
    }
    return '';
}

function getProcessName() {
    if (window.location.pathname.includes('fnol') || window.location.pathname.includes('/claimshub/confirmation/')) {
        return 'Claims Hub FNOL';
    }
    return '';
}

function getStep() {
    if (window.location.pathname.includes('fnol-select-policy') || window.location.pathname.includes('fnol-ca/select-policy')) {
        return '1,FNOL - Select Policy';
    } if (window.location.pathname.includes('fnol-ca/what')) {
        return '2,FNOL - What';
    } if (window.location.pathname.includes('fnol-ca/details')) {
        return '3,FNOL - Details';
    } if (window.location.pathname.includes('fnol-ca/Vehicles')) {
        return '4,FNOL - Vehicles';
    } if (window.location.pathname.includes('fnol-ca/type-of-repair') || window.location.pathname.includes('fnol-ca/repair')) {
        return '5,FNOL - Repair';
    } if (window.location.pathname.includes('fnol-ca/additionalinformation')) {
        return '6,FNOL - Additional Information';
    } if (window.location.pathname.includes('fnol-ca/contact-details')) {
        return '7,FNOL - Contact';
    } if (window.location.pathname.includes('fnol-ca/summary')) {
        return '8,FNOL - Summary';
    } if (window.location.pathname.includes('/claimshub/confirmation/')) {
        return '9,FNOL - Confirmation';
    }
    return '';
}

function getPreviousStep() {
    if (digitalData) {
        if (digitalData.spaData) {
            if (digitalData.spaData.AllianzClaimsHub) {
                if (digitalData.spaData.AllianzClaimsHub.pageChanged) {
                    if (window.digitalData.spaData.AllianzClaimsHub.pageChanged.oldPage) {
                        const { oldPage } = window.digitalData.spaData.AllianzClaimsHub.pageChanged;
                        if (oldPage === 'FNOL - Select Policy') {
                            return '1,FNOL - Select Policy';
                        } if (oldPage === 'FNOL - What') {
                            return '2,FNOL - What';
                        } if (oldPage === 'FNOL - Details') {
                            return '3,FNOL - Details';
                        } if (oldPage === 'FNOL - Vehicles') {
                            return '4,FNOL - Vehicles';
                        } if (oldPage === 'FNOL - Repair') {
                            return '5,FNOL - Repair';
                        } if (oldPage === 'FNOL - Additional Information') {
                            return '6,FNOL - Additional Information';
                        } if (oldPage === 'FNOL - Contact') {
                            return '7,FNOL - Contact';
                        } if (oldPage === 'FNOL - Summary') {
                            return '8,FNOL - Summary';
                        } if (oldPage === 'FNOL - Confirmation') {
                            return '9,FNOL - Confirmation';
                        }
                    }
                }
            }
        }
    }
    return '';
}

function getProcessStartDate(currentPage) {
    if (currentPage === 'FNOL - Select Policy') {
        return (Date.now());
    } if (currentPage.includes('FNOL') && (currentPage !== 'FNOL - Select Policy')) {
        return window.digitalData.process.startTime;
    }
    return Date.now();
}

function addAnalyticsElements() {
    initialiseTrackify();
    const currentPage = getPageName();
    const oldPage = getPreviousPageName();
    const processname = getProcessName();
    const step = getStep();
    const previousStep = getPreviousStep();
    const startDate = getProcessStartDate(currentPage);

    const page = {
        pageChange: {
            newPage: currentPage
        },
        pageInfo: {
            pageType: getPageType(),
            fullURL: window.location.href,
            siteSection: getSiteSection()
        }
        // Add other properties as needed
    };
    const application = {
        name: 'Allianz Claims Hub'
    };

    window.digitalData = {
        ...window.digitalData, // Preserve existing data (if any)
        page,
        application,
    };
    window.digitalData.page.pageChange = {
        ...window.digitalData.page.pageChange,
        oldPage
    };
    if (processname === 'Claims Hub FNOL') {
        const process = {
            startTime: startDate,
            processName: processname,
            stepNumber: step.split(',')[0],
            stepName: step.split(',')[1],
            previousStepNumber: previousStep.split(',')[0],
            previousStepName: previousStep.split(',')[1],
        };
        window.digitalData = {
            ...window.digitalData, // Preserve existing data (if any)
            process,
        };
    } else {
        window.digitalData = {
            ...window.digitalData, // Preserve existing data (if any)
            process: '',
        };
    }

    if (window.digitalData) {
        if (window.digitalData.spaData) {
            if (window.digitalData.spaData.AllianzClaimsHub) {
                if (window.digitalData.spaData.AllianzClaimsHub.applicationPageChanged) {
                    if (window.digitalData.spaData.AllianzClaimsHub.applicationPageChanged !== currentPage) {
                        pushEvent('applicationPageChanged', currentPage, true);
                    }
                } else if (window.digitalData.spaData.AllianzClaimsHub.pageChanged) {
                    if (currentPage !== 'AZ dashboard') {
                        pushEvent('applicationPageChanged', currentPage, true);
                    }
                }
            }
        }
    }
}

function getActiveTile(id) {
    if (id == 'all') {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: 'claimshub_all open'
                }
            },
        };
        pushEvent('summaryTileChanged', 'claimshub_all open', true);
    } else if (id === 'allclosed') {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: 'claimshub_closed claims'
                }
            },
        };
        pushEvent('summaryTileChanged', 'claimshub_closed claims', true);
    } else if (id === 'allopen') {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: 'claimshub_open claims'
                }
            },
        };
        pushEvent('summaryTileChanged', 'claimshub_open claims', true);
    } else if (id === 'recentlynotified') {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: 'claimshub_recently notified'
                }
            },
        };
        pushEvent('summaryTileChanged', 'claimshub_recently notified', true);
    } else if (id === 'recentlyclosed') {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: 'claimshub_recently closed'
                }
            },
        };
        pushEvent('summaryTileChanged', 'claimshub_recently closed', true);
    } else {
        window.digitalData = {
            ...window.digitalData,
            event: '',
        };
    }
}

function searchInputDropDown(dropDownValue, inputValue) {
    if (dropDownValue === 'claimnumber') {
        window.digitalData = {
            ...window.digitalData,
            search: {
                type: 'claimshub_claim-filter.claim number',
                searchTerm: inputValue
            }
        };
        pushEvent('search', 'claimshub_claim-filter.claim number', true);
    }
    if (dropDownValue === 'insured') {
        window.digitalData = {
            ...window.digitalData,
            search: {
                type: 'claimshub_claim-filter.insured',
                searchTerm: inputValue
            }
        };
        pushEvent('search', 'claimshub_claim-filter.insured', true);
    }
    if (dropDownValue === 'policynumber') {
        window.digitalData = {
            ...window.digitalData,
            search: {
                type: 'claimshub_claim-filter.policy number',
                searchTerm: inputValue
            }
        };
        pushEvent('search', 'claimshub_claim-filter.policy number', true);
    }
    if (dropDownValue === 'vehicleregistration') {
        window.digitalData = {
            ...window.digitalData,
            search: {
                type: 'claimshub_claim-filter.vehicle registration',
                searchTerm: inputValue
            }
        };
        pushEvent('search', 'claimshub_claim-filter.vehicle registration', true);
    }
    if (dropDownValue === 'brokerreference') {
        window.digitalData = {
            ...window.digitalData,
            search: {
                type: 'claimshub_claim-filter.broker reference',
                searchTerm: inputValue
            }
        };
        pushEvent('search', 'claimshub_claim-filter.broker reference', true);
    }
}

function fullSummaryOverview(fullSummaryView) {
    if (fullSummaryView !== 'clicked') {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: 'claimshub_status.full overview'
                }
            },
        };
        pushEvent('summaryTabChanged', 'claimshub_status.full overview', true);
    } else {
        window.digitalData = {
            ...window.digitalData,
            event: {
                label: {
                    myaz_event: ''
                }
            },
        };
    }
}

function policyCoverAccordion() {
    window.digitalData = {
        ...window.digitalData,
        event: {
            label: {
                myaz_event: 'claimshub_status.policy cover'
            }
        },
    };
    pushEvent('summaryTabChanged', 'claimshub_status.policy cover', true);
}

function liabilityAccordion() {
    window.digitalData = {
        ...window.digitalData,
        event: {
            label: {
                myaz_event: 'claimshub_status.liability'
            }
        },
    };
    pushEvent('summaryTabChanged', 'claimshub_status.liability', true);
}

function vehicleAccordion() {
    window.digitalData = {
        ...window.digitalData,
        event: {
            label: {
                myaz_event: 'claimshub_status.vehicle'
            }
        },
    };
    pushEvent('summaryTabChanged', 'claimshub_status.vehicle', true);
}

function thirdPartyAccordion() {
    window.digitalData = {
        ...window.digitalData,
        event: {
            label: {
                myaz_event: 'claimshub_status.third party'
            }
        },
    };
    pushEvent('summaryTabChanged', 'claimshub_status.third party', true);
}

function recoveryAccordion() {
    window.digitalData = {
        ...window.digitalData,
        event: {
            label: {
                myaz_event: 'claimshub_status.recovery'
            }
        },
    };
    pushEvent('summaryTabChanged', 'claimshub_status.recovery', true);
}

function getQuestionByID(qID) {
    if (qID === 'accordion_gw-faq-about-portal-for-producers') {
        return 'Can I report all claims via Allianz Claims Hub?';
    } if (qID === 'accordion_gw-faq-sev-injury-for-producers') {
        return 'Can I use Allianz Claims Hub to report a claim where there is a severe injury or fatality?';
    } if (qID === 'accordion_gw-faq-wind-screen-for-producers') {
        return 'Can I use Allianz Claims Hub to report a windscreen claim?';
    } if (qID === 'accordion_gw-faq-upload-docs-for-producers') {
        return 'How do I upload documents, photos and videos?';
    } if (qID === 'accordion_gw-faq-doc-type-for-producers') {
        return 'Which types of documents can I upload?';
    } if (qID === 'accordion_gw-faq-doc-size-for-producers') {
        return 'Is there a size limit for uploading documents and videos?';
    } if (qID === 'accordion_gw-faq-repair-method-for-producers') {
        return 'Which repair method do I select if I have preferred approved repairer?';
    } if (qID === 'accordion_gw-faq-report-info-for-producers') {
        return 'What if I need to make the handler aware of other information when reporting a new claim?';
    } if (qID === 'accordion_gw-faq-report-probs-for-producers') {
        return 'What do I do if I am having problems reporting my claim?';
    } if (qID === 'accordion_gw-faq-finance-info-for-producers') {
        return 'How do I access financial information?';
    } if (qID === 'accordion_gw-faq-claim-status-for-producers') {
        return 'How do I check the present position of a claim?';
    } if (qID === 'accordion_gw-faq-open-claim-for-producers') {
        return 'Why is my claim still showing as open?';
    } if (qID === 'accordion_gw-faq-feedback-for-producers') {
        return 'How do I provide feedback about the Allianz Claims Hub?';
    }
    return '';
}

function onClickFAQ(qID) {
    if (qID !== null) {
        if (getQuestionByID(qID) !== '') {
            pushEvent('applicationFAQ', getQuestionByID(qID), true);
            window.digitalData = {
                ...window.digitalData,
                event: {
                    label: {
                        myaz_event: getQuestionByID(qID)
                    }
                }
            };
        }
    }
}

function onFAQSearchText(searchText) {
    window.digitalData = {
        ...window.digitalData,
        search: {
            searchTerm: searchText
        }
    };
}

function setProfileID(authHeader) {
    if (!window.digitalData.user) {
        const profileIDPromise = UserProfileIDService.getProfileID(authHeader);
        profileIDPromise
            .then((responseData) => {
                window.digitalData = {
                    ...window.digitalData,
                    user: {
                        profileId: responseData.profileID,
                        role: responseData.role
                    },
                };
                pushEvent('userProfileAdded', `${responseData.role}_${responseData.profileID}`, true);
            })
            .catch(() => {
                pushEvent('userProfileNotAdded', 'Error Occured while fetching profileID', true);
            });
    }
}

function approvedRepairerInstructions(status) {
if (!window.digitalData.claim) {
    window.digitalData.claims = {
        ...window.digitalData.claims,
        approvedRepairer: {
            status: status,
        },
    };
    pushEvent('approvedRepairerInstruction', `${status}`, true);
}
}

function claimID(claimNumber) {
    if (!window.digitalData.claim) {
        
        window.digitalData= {
            ...window.digitalData,
            Claim: {
                claimID : claimNumber
             },
        };
    pushEvent('claimIDAdded', `${claimNumber}`, true);

    }
}

// EXPORT``
export default {
    addAnalyticsElements,
    getActiveTile,
    setProfileID,
    searchInputDropDown,
    fullSummaryOverview,
    policyCoverAccordion,
    liabilityAccordion,
    vehicleAccordion,
    thirdPartyAccordion,
    recoveryAccordion,
    tabChange,
    onClickFAQ,
    onFAQSearchText,
    approvedRepairerInstructions,
    claimID
};
